(function() {
  'use strict';
  
  // Vérifier qu'on est sur la homepage
  if (!document.body.classList.contains('template-index')) {
    return;
  }

  // Essayer différents sélecteurs pour trouver le logo
  const logoSelectors = [
    '.header__logo-image',
    '.header__heading-logo',
    '.header__logo img',
    '.header-logo img',
    'header img[alt*="logo"]',
    'header .logo img'
  ];
  
  let logo = null;
  
  for (let selector of logoSelectors) {
    logo = document.querySelector(selector);
    if (logo) {
      console.log('Logo trouvé avec le sélecteur:', selector);
      break;
    }
  }
  
  if (!logo) {
    console.error('Logo non trouvé. Vérifiez le sélecteur.');
    return;
  }

  let hasScrolled = false;

  // Appliquer l'état initial (agrandi)
  function initLogo() {
    logo.style.transition = 'transform 0.8s cubic-bezier(0.4, 0, 0.2, 1)';
    logo.style.transformOrigin = 'center';
    logo.style.transform = 'scale(1.3)';
  }

  // Gérer le scroll
  function handleScroll() {
    const scrollY = window.scrollY || window.pageYOffset;
    const threshold = 50;

    if (scrollY > threshold && !hasScrolled) {
      hasScrolled = true;
      logo.style.transform = 'scale(1)';
    } else if (scrollY <= threshold && hasScrolled) {
      hasScrolled = false;
      logo.style.transform = 'scale(1.3)';
    }
  }

  // Initialiser
  setTimeout(initLogo, 100);

  // Écouter le scroll
  window.addEventListener('scroll', handleScroll, { passive: true });
})();
